import * as apis from "@/apis/from-password-to-set";

export default {
    getCaptchaFPTS(context, params) {
        return apis.getCaptcha(params);
    },
    verifyPwdFPTS(context, params) {
        return apis.verifyPwd(params);
    },
    setSecurityFPTS(context, params) {
        return apis.setSecurity(params);
    },
    sendCodeFPTS(context, params) {
        return apis.sendCode(params);
    }
};
